const btnRadios = document.querySelectorAll('.btn-radio');
btnRadios.forEach(function(btnRadio){
	const input = btnRadio.querySelector('input');
	if(input.disabled === false){
		btnRadio.addEventListener('click', function(e){
			e.preventDefault();
			if(input.checked){
				input.checked = false;
			}
			else{
				input.checked = true;
			}
			input.closest('form').submit();
		})
	}
})

const donateUserSearch = document.getElementById('donate-user-search');
if(donateUserSearch){
	donateUserSearch.addEventListener('click', function (e) {
		const donateUserSearchTerms = this.value; 
		setTimeout(() => {
			if(donateUserSearchTerms.length && !e.target.value.length){
				donateUserSearch.closest('form').submit();
			}
		}, 1);
	});
}

const filterToggler = document.getElementById('filter-toggler');
if(filterToggler){

	const filterTop = filterToggler.closest('.filter-top');
	const filterTopBody = filterTop.querySelector('.filter-top-body');
	filterToggler.addEventListener('click', function(e){

		if(filterTop.classList.contains('open')){
			filterTop.classList.remove('open');
		}
		else{
			filterTop.classList.add('open');
		}
	})
}
